/*
 * @Author: liyxt
 * @Date: 2020-05-06 14:00:41
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 15:04:22
 * @Description: file content
 */ 
import React, { Component } from 'react';
//import { Row as OriginRow } from 'bee-layout';
//require('bee-layout/build/Layout.css');
import { Row as OriginRow } from '@tinper/next-ui';
import { Col as OriginCol } from '@tinper/next-ui';
export default class Row extends Component {
    render() {
        let { cols, ...others } = this.props;
        if (Array.isArray(cols) && cols.length) {
            return <OriginRow {...others}>{cols.map((col, index) => {
                return <OriginCol key={index} {...col}>{col?.render?.()}</OriginCol>;
            })}</OriginRow>;
        }
        return <OriginRow {...others}></OriginRow>;
    }
}
